import { render, staticRenderFns } from "./ExtensionAndEndorsements.vue?vue&type=template&id=c7381212&scoped=true&"
import script from "./ExtensionAndEndorsements.vue?vue&type=script&lang=js&"
export * from "./ExtensionAndEndorsements.vue?vue&type=script&lang=js&"
import style0 from "./ExtensionAndEndorsements.vue?vue&type=style&index=0&id=c7381212&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7381212",
  null
  
)

export default component.exports